import { BASE_API } from "../../configs/ConfigsConstants";

export async function getScheduleApi() {
    try {
        const url = `${BASE_API}/hrm/api/schedules/`;
        const params = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}

export async function addScheduleApi(data) {
    try {
        const url = `${BASE_API}/hrm/api/save_schedule/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
export async function updateScheduleApi(data) {
    try {
        const url = `${BASE_API}/hrm/api/update_schedule/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
export async function deleteScheduleApi(id) {
    try {
        const url = `${BASE_API}/hrm/api/delete_schedule/${id}/`;
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
}
